import { CustomTheme } from 'themes/types'

import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: CustomTheme) => ({
    root: {
        width: 36,
        height: 18,
        padding: 0,
        display: 'flex',
        borderRadius: 10,
    },
    box: {
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',

            '& .dateContainer > div': {
                flexDirection: 'column',
            },
        },
    },
    dateRangeField: {
        width: '100%',
        '& + div': {
            marginLeft: 20,

            [theme.breakpoints.down('lg')]: {
                margin: '20px 0 0',
            },
        },
    },
    track: {
        backgroundColor: '#DDDDDD',
    },
    thumb: {
        width: 14,
        height: 14,
        boxShadow: 'none',
    },
    switchBase: {
        padding: 2,
        color: '#fff',
        '&$checked': {
            transform: 'translateX(19px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.color.button.radioActive,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    downloadBtnWrap: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        minHeight: 38,

        '& > div, & > img': {
            width: 38,
            height: 38,
            marginRight: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },

        [theme.breakpoints.down('md')]: {
            marginTop: 20,
        },

        [theme.breakpoints.down('lg')]: {
            justifyContent: 'flex-start',
            marginBottom: 20,
            '& > div:last-child, & > img:last-child': {
                marginRight: 0,
            },
        },
    },
    downloadBtn: {
        cursor: 'pointer',
    },
    selectInputs: {
        minWidth: 210,
        flex: 1,
        margin: '0',
        [theme.breakpoints.down('md')]: {
            margin: '0 0 20px 0 !important',
        },
        [theme.breakpoints.down('lg')]: {
            marginTop: 20,
            width: '100%',

            // '&:nth-child(2)': {
            //     marginLeft: '20px',
            // },

            '&:last-child': {
                marginRight: 0,
            },

            '& > div': {
                marginRight: 0,
            },
        },
    },
    selectStatus: {
        [theme.breakpoints.down('lg')]: {
            marginTop: '20px !important',
            marginBottom: '20px !important',
        },
    },
    filterButton: {
        [theme.breakpoints.down('lg')]: {
            width: '100% !important',
        },
        [theme.breakpoints.down('md')]: {
            marginTop: '0 !important',
        },
    },
    tableContainer: {
        backgroundColor: '#ffffff',
    },
    rowRoot: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
}))
